import { Button, DraggableCarousel } from "../../../components/ui";
import localization from "../../../config/localization";

interface ResponsibleGamingTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function ResponsibleGamingTabs({
  activeTab,
  onTabChange,
}: ResponsibleGamingTabsProps) {
  const tabs = [
    {
      id: "deposit-limit",
      label: localization.deposit_limit,
    },
    {
      id: "take-a-break",
      label: localization.take_a_break,
    },
    {
      id: "self-exclusion",
      label: localization.self_exclusion,
    },
  ];

  return (
    <div className="sticky top-0 z-10 overflow-hidden">
      <div className="px-4 pt-4 pb-2">
        <DraggableCarousel>
          <div className="flex items-center gap-4 min-w-max">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;

              return (
                <div key={tab.id} className="shrink-0 flex rounded-lg">
                  <Button
                    onClick={() => onTabChange(tab.id)}
                    className="flex flex-col items-center gap-1.5 min-w-[110px] px-2"
                  >
                    <span
                      className={`text-sm sm:text-base font-medium whitespace-nowrap text-center transition-colors duration-300 ${isActive ? "text-white" : "text-gray-400"
                        }`}
                    >
                      {tab.label}
                    </span>

                    <span
                      className={`h-[2px] w-full rounded-full transition-all duration-300 ${isActive ? "bg-[#FF94B1]" : "bg-transparent"
                        }`}
                    />
                  </Button>
                </div>
              );
            })}
          </div>
        </DraggableCarousel>
      </div>
    </div>
  );
}
